var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"l-content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-16 col-xs-offset-1"},[_c('div',{staticClass:"se-snapshot__above"},[_vm._t("above")],2),_vm._v(" "),_c('div',{staticClass:"se-snapshot"},[_vm._t("default")],2)])])])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4be73c6d","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Snapshot.vue
// module id = null
// module chunks = 